import Vue from 'vue'
import { sendRequest, tokenRefresh } from "@/api"

const intialFormData = () => {
  return {
    id: null,
    status: 9,
    name: null,
    canVoted: false,
    description: null,
    descriptionEN: null,
    shortDescription: null,
    shortDescriptionEN: null,
    mainImage: null,
    mainImageWidth: null,
    mainImageHeight: null,
    doc: {},
    formSaveSuccess: false,
    formSaveError: false,
    appleMusicUrl: null,
    facebookUrl: null,
    instagramUrl: null,
    tiktokUrl: null,
    spotifyUrl: null,
    youtubeUrl: null,
    youtubeVideoIds: null,
    spotifyEmbedCode: null,
  }
}

export const artists = {
  state: {
    form: intialFormData(),
    all: [],
  },
  mutations: {
    setArtistData(state, payload) {
      const { key, value } = payload
      const { form } = state

      Vue.set(form, key, value)
    },
    saveArtist(state, payload) {
      const { success, artist } = payload
      const { form } = state

      if (success) {
        Vue.set(form, 'formSaveSuccess', true)
        Vue.set(state, 'all', state.all.map((a) => parseInt(a.id) === parseInt(artist.id) ? artist : a))
      } else {
        Vue.set(form, 'formSaveError', true)
      }
    },
    artistImageUploaded(state, payload) {
      const { key, value } = payload
      const { form } = state

      if (!form[key]) {
        Vue.set(form, key, null)
      }

      Vue.set(form, key, value)
    },
    setArtists(state, payload) {
      const { artists } = payload
      Vue.set(state, 'all', artists)
    },
    fillArtistForm(state, payload) {
      const { artistId } = payload
      const artist = state.all.find((a) => parseInt(a.id) === parseInt(artistId))
      const { form } = state
      Vue.set(form, 'id' , artist.id)
      Vue.set(form, 'status' , artist.artist_status)
      Vue.set(form, 'name' , artist.name)
      Vue.set(form, 'canVoted' , artist.can_voted)
      Vue.set(form, 'description' , artist.desc)
      Vue.set(form, 'shortDescription' , artist.desc_short)
      Vue.set(form, 'descriptionEN' , artist.desc_en)
      Vue.set(form, 'shortDescriptionEN' , artist.desc_short_en)
      Vue.set(form, 'mainImage' , artist.image_url)
      Vue.set(form, 'doc' , artist.doc)
      Vue.set(form, 'appleMusicUrl' , artist.apple_music_url || '')
      Vue.set(form, 'facebookUrl' , artist.facebook_url || '')
      Vue.set(form, 'instagramUrl' , artist.instagram_url || '')
      Vue.set(form, 'tiktokUrl' , artist.tiktok_url || '')
      Vue.set(form, 'spotifyUrl' , artist.spotify_url || '')
      Vue.set(form, 'youtubeUrl' , artist.youtube_url || '')
      Vue.set(form, 'youtubeVideoIds' , artist.youtube_video_ids || '')
      Vue.set(form, 'spotifyEmbedCode' , artist.spotify_embed_code || '')
    }
  },
  actions: {
    setArtists(context, payload) {
      context.commit('setArtists', payload)
    },
    fillArtistForm(context, payload) {
      context.commit('fillArtistForm', payload)
    },
    artistImageUploaded(context, payload) {
      context.commit('artistImageUploaded', payload)
    },
    setArtistData(context, payload) {
      context.commit('setArtistData', payload)
    },
    async saveArtist(context, payload) {
      const { id, form } = payload
      let formData = new FormData()

      formData.append('name', form.name)
      formData.append('canVoted', form.canVoted)
      formData.append('status', form.status)
      formData.append('description', form.description ? form.description : '')
      formData.append('descriptionEN', form.descriptionEN ? form.descriptionEN : '')
      formData.append('shortDescription', form.shortDescription ? form.shortDescription : '')
      formData.append('shortDescriptionEN', form.shortDescriptionEN ? form.shortDescriptionEN : '')
      formData.append('mainImageHeight', form.mainImageHeight)
      formData.append('mainImageWidth', form.mainImageWidth)

      formData.append('appleMusicUrl', form.appleMusicUrl)
      formData.append('facebookUrl', form.facebookUrl)
      formData.append('instagramUrl', form.instagramUrl)
      formData.append('tiktokUrl', form.tiktokUrl)
      formData.append('spotifyUrl', form.spotifyUrl)
      formData.append('youtubeUrl', form.youtubeUrl)
      formData.append('youtubeVideoIds', form.youtubeVideoIds)
      formData.append('spotifyEmbedCode', form.spotifyEmbedCode)
      
      if (typeof form.mainImage === 'object') formData.append('mainImage', form.mainImage)
      
      await tokenRefresh()
      const { ok, data: { artist } } = await sendRequest(
        "post",
        `api/artist/${id}/update/`,
        formData,
        'text'
      )

      if (ok === true) {
        context.commit('saveArtist', { success: true, artist })
      } else {
        context.commit('saveArtist', { success: false, artist })
      }
    },
  },
}